<script setup lang="ts">
import agentConversation from "~/assets/icons/agent/agent-conversation.svg"

const props = defineProps({
  conversation: null,
  fractionalIndex: null,
  dragOver: { type: Boolean }
})
const { isSelectedIn } = useSelection()
const { navigateToConversation } = useNavigation()
const { isDragging } = useGestures()

const hoverable = computed(() => !isDragging.value)
const sidebarSelection = computed(() => isSelectedIn(props.conversation.id, "sidebar"))

function onChatClick() {
  return navigateToConversation(props.conversation)
}
</script>

<template>
  <sidebar-entry-item
    :conversation-id="conversation.id"
    :fractional-index
  >
    <template #item>
      <div class="agent-conversation" @click="onChatClick">
        <div class="agent-conversation-icon">
          <agent-conversation class="icon" />
        </div>
        <div class="agent-title">
          {{ conversation.title() || 'Untitled' }}
        </div>
      </div>
    </template>
  </sidebar-entry-item>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.agent-conversation
  @apply font-[350] text-[12px] tracking-[0.016em]
  @apply flex items-center gap-[#{$sidebar-gap-item}]
  @apply cursor-pointer

.agent-conversation-icon
  @apply h-4 w-4 flex-none flex items-center justify-center
  .icon
    @apply h-4.5

.agent-title
  @apply text-ellipses-inline
</style>
